import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { EMAIL_PATTERN } from '@avanta/shared/constants/patterns';

export const initialFormData = {
  email: '',
};

export const formValidation = {
  email: {
    required: `${LOCIZE_NS.COMMON}:Common.required`,
    pattern: {
      value: EMAIL_PATTERN,
      message: `${LOCIZE_NS.COMMON}:Common.invalidEmail`,
    },
  },
};
